export default __webpack_public_path__ + "static/media/calendar.976f4781.svg";